import { render, staticRenderFns } from "./DramaContent.vue?vue&type=template&id=76ccd5d9&scoped=true"
import script from "./DramaContent.vue?vue&type=script&lang=js"
export * from "./DramaContent.vue?vue&type=script&lang=js"
import style0 from "./DramaContent.vue?vue&type=style&index=0&id=76ccd5d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ccd5d9",
  null
  
)

export default component.exports